import React, { useContext } from 'react';
var RenderAuthorContext = React.createContext(undefined);
export var RenderAuthorProvider = RenderAuthorContext.Provider;
export var useRenderAuthorCallback = function () { return useContext(RenderAuthorContext); };
//# sourceMappingURL=renderAuthor.js.map